import $ from 'jquery';
import AbstractPage from './AbstractPage';
import TweenMax from 'gsap';
import Parallax from 'parallax-js';
import {
  getIEVersion,
  not,
  // isMobileResolution,
  // getResolution,
  // getReencodedUriParams,
  // getUriCombinedParams,
  isMobileEnv
} from '../util/util';
// import { TRACKING } from '../model/config';
class Intro extends AbstractPage {
  constructor(options) {
    super(options);

    const _ = this;

    // _.option
    // _.model

    //console.log('_.option :', _.option);

    _.transitionController = null;

    _.$logo = $('.logo', _.$wrap);
    _.$title = $('.header .title', _.$wrap);
    _.$subCopy = $('.header .subcopy', _.$wrap);
    _.$date = $('.header .date', _.$wrap);
    _.$preorderBtn = $('.btn-preorder', _.$wrap);
    _.$playBtn = $('.btn-youtube', _.$wrap);

    _.$movieIntro = $('.video', _.$wrap);
    _.$movieIntroEnter = $('.video.movie-intro-enter', _.$wrap);
    _.$movieIntroLoop = $('.video.movie-intro-loop', _.$wrap);

    _.$character1 = $('.el-intro-character1 .el', _.$wrap);
    _.$character2 = $('.el-intro-character2 .el', _.$wrap);

    //0212 ver
    _.$character = $('.el-intro-character .el', _.$wrap);

    _.MIN_WINDOW_HEIGHT = 1100;
    _.VIDEO_RATIO = 1.77;

    this._firsEnter = true;
    this.isSection0212 = _.$wrap.hasClass('section-intro-0212');
    this._setParallax();
  }

  init(obj = null) {
    super.init(obj);
    const _ = this;

    if (not(isMobileEnv)($('body'))) {
      const ua = window.navigator.userAgent;

      console.log('getIEVersion(ua) :', getIEVersion(ua));
    }

    // _._setPreorderLinkBtn();

    // (!_.isSection0212) &&  _._setIntroMovie();

    _._reset();

    console.log('init Intro Page');
    return _;
  }

  // _setPreorderLinkBtn() {
  //   const _ = this,
  //     $goPreorderBtn = $('.btn-preorder', _.$wrap),
  //     params = getReencodedUriParams(location.href) || {},
  //     url = getUriCombinedParams($goPreorderBtn.attr('href') || '', params);

  //   console.log(url);

  //   $goPreorderBtn.attr('href', url);

  //   $goPreorderBtn.on('click', evt => {
  //     console.log('click preorder button');

  //     // if (window.ga) {
  //     //   // google analytics tracking
  //     //   window.ga('send', {
  //     //     hitType: 'event',
  //     //     eventCategory: 'Click',
  //     //     eventAction: 'Preorder button',
  //     //     eventLabel: EVENT_CODE
  //     //   });
  //     // }

  //     // icast ad tracking
  //     let img = new Image();
  //     if (isMobileEnv($('body'))) {
  //       // mobile env
  //       img.src = TRACKING.MOBILE_PREORDER_BUTTON_CLICK;
  //     } else {
  //       // pc
  //       img.src = TRACKING.PC_PREORDER_BUTTON_CLICK;
  //     }

  //     // GDN tracking
  //     // gtag_report_conversion(url);

  //     // function gtag_report_conversion(url) {
  //     //   console.log('gtag_report_conversion :', url);

  //     //   if (window.gtag) {
  //     //     var callback = function() {
  //     //       // if (typeof url != 'undefined') window.location = url;
  //     //     };

  //     //     window.gtag('event', 'conversion', {
  //     //       send_to: 'AW-864659659/ZAGBCJG7yIgBEMvRppwD',
  //     //       transaction_id: '',
  //     //       event_callback: callback
  //     //     });
  //     //   }

  //     //   return false;
  //     // }

  //     /*
  //     if (window.gtag) {
  //         var callback = function() {
  //             if (typeof url != 'undefined') {
  //                 window.location = url;
  //             }
  //         };

  //         window.gtag('event', 'conversion', {
  //             send_to: 'AW-864659659/ZAGBCJG7yIgBEMvRppwD',
  //             transaction_id: '',
  //             event_callback: callback
  //         });
  //     }
  //     */
  //   });
  // }

  enter(obj = null) {
    const _ = this;

    // if(!_.isSection0212 && this._firsEnter && not(isMobileEnv)($("body"))){
    //   return _;
    // }else{
    //   _._startAnimation();
    // }

    _._startAnimation();

    return _;
  }

  exit(obj = null) {
    const _ = this;

    _._reset();

    return _;
  }

  _startAnimation() {
    const _ = this;

    // _.$logo,
    // _.$title,
    // _.$subCopy,
    // _.$date,
    // _.$preorderBtn

    // TweenMax.killTweensOf([
    //   _.$logo,
    //   _.$title,
    //   _.$subCopy,
    //   _.$date,
    //   _.$preorderBtn
    // ]);

    // TweenMax.to(_.$logo, 1.5, {
    //   delay: 0.45,
    //   y: 0,
    //   opacity: 1,
    //   ease: Cubic.easeOut
    // });
    // TweenMax.to(_.$title, 1.5, {
    //   delay: 0.45,
    //   y: 0,
    //   opacity: 1,
    //   ease: Expo.easeOut
    // });

    // TweenMax.to(_.$subCopy, 1.8, {
    //   delay: 0.85,
    //   y: 0,
    //   opacity: 1,
    //   ease: Expo.easeOut
    // });
    // TweenMax.to(_.$date, 1.8, {
    //   delay: 1.05,
    //   y: 0,
    //   opacity: 1,
    //   ease: Expo.easeOut
    // });
    // TweenMax.to(_.$preorderBtn, 1.8, {
    //   delay: 1.15,
    //   y: 0,
    //   opacity: 1,
    //   ease: Expo.easeOut
    // });

    if (_.isSection1107) {
      TweenMax.killTweensOf([
        _.$character,
        _.$logo,
        _.$title,
        _.$subCopy,
        _.$playBtn,
        _.$preorderBtn
      ]);

      TweenMax.to(_.$logo, 1.5, {
        delay: 0.15,
        y: 0,
        opacity: 1,
        ease: Cubic.easeOut
      });
      TweenMax.to(_.$title, 1.5, {
        delay: 0.15,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });

      TweenMax.to(_.$subCopy, 1.8, {
        delay: 0.45,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$playBtn, 1.8, {
        delay: 0.65,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$preorderBtn, 1.8, {
        delay: 0.65,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$character, 1.5, {
        x: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
    } else {
      TweenMax.killTweensOf([
        _.$character1,
        _.$character2,
        _.$logo,
        _.$title,
        _.$subCopy,
        _.$playBtn,
        _.$preorderBtn
      ]);

      TweenMax.to(_.$logo, 1.5, {
        delay: 0.15,
        y: 0,
        opacity: 1,
        ease: Cubic.easeOut
      });
      TweenMax.to(_.$title, 1.5, {
        delay: 0.15,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });

      TweenMax.to(_.$playBtn, 1.8, {
        delay: 0.45,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$subCopy, 1.8, {
        delay: 0.65,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$preorderBtn, 1.8, {
        delay: 0.65,
        y: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$character1, 1.5, {
        delay: 0.2,
        x: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
      TweenMax.to(_.$character2, 1.5, {
        x: 0,
        opacity: 1,
        ease: Expo.easeOut
      });
    }

    this._firsEnter = false;

    return _;
  }

  _reset() {
    const _ = this;

    if (_.isSection1107) {
      TweenMax.killTweensOf([
        _.$character,
        _.$logo,
        _.$title,
        _.$subCopy,
        _.$playBtn,
        _.$preorderBtn
      ]);

      TweenMax.set(_.$character, {
        x: 200,
        opacity: 0
      });
      TweenMax.set(_.$logo, {
        y: -10,
        opacity: 0
      });
      TweenMax.set(_.$title, {
        y: -20,
        opacity: 0
      });
    } else {
      TweenMax.killTweensOf([
        _.$character1,
        _.$character2,
        _.$logo,
        _.$title,
        _.$subCopy,
        _.$playBtn,
        _.$preorderBtn
      ]);

      TweenMax.set(_.$character1, {
        x: 220,
        opacity: 0
      });
      TweenMax.set(_.$character2, {
        x: 200,
        opacity: 0
      });
      TweenMax.set(_.$logo, {
        y: -10,
        opacity: 0
      });
      TweenMax.set(_.$title, {
        y: -20,
        opacity: 0
      });
    }

    return _;
  }

  resize(evt = null) {
    const _ = this;

    // let $window = $(window);
    // let windowWidth = $window.width();
    // let windowHeight =  $window.height() <= _.MIN_WINDOW_HEIGHT ? _.MIN_WINDOW_HEIGHT : $window.height();

    // const windowRatio =  windowWidth /  windowHeight;
    // const videoRatio = _.VIDEO_RATIO;

    // console.log('$window.width()', $window.width());
    // console.log('$window.height()', $window.height());
    // console.log('windowRatio', windowRatio);

    // console.log('videoRatio', videoRatio);

    // if (videoRatio > windowRatio) {
    //   _.$movieIntro.css({ width: 'auto', height: '100%' });
    //   console.log("{ width: 'auto', height: '100%' }")
    // } else {
    //   _.$movieIntro.css({ width: '100%', height: 'auto' });
    //   console.log("{ width: '100%', height: 'auto' }")
    // }

    return _;
  }

  destroy(obj = null) {
    super.destroy(obj);

    const _ = this;

    return _;
  }

  _setParallax() {
    const _ = this;

    if (!$('body').hasClass('pc')) return;

    // if (!_.isSection1107) return;
    new Parallax(document.getElementById('introObj'), {
      scalarX: 10,
      scalarY: 1,
      friction: 0.2
    });

    return _;
  }

  // _setIntroMovie(){
  //   const _ = this;
  //   console.log('init setIntroMovie')
  //   _.movieIntroEnter = _.$movieIntroEnter[0];
  //   _.movieIntroLoop = _.$movieIntroLoop[0];

  //   if(!_.movieIntroEnter || !_.movieIntroLoop ) return false;

  //   $('.bg-wrap .bg-intro').css({background:'none'});
  //   $('#sectionIntro').css({background:'none'});

  //   _.movieIntroEnter.play();
  //   // _._onPlayMovieIntroEnter();

  //   // _._onEndedMovieIntroEnter();

  //   _.movieIntroEnter.addEventListener('timeupdate', () => {
  //     _._onTimeupdateMovieIntroEnter();
  //   });

  //   _.movieIntroEnter.addEventListener('ended', () => {
  //     _._onEndedMovieIntroEnter();
  //   });

  //   // _.movieIntroEnter.addEventListener('canplaythrough', () => {
  //   //   _.movieIntroEnter.play();
  //   // });

  //   _.movieIntroEnter.addEventListener('play', () => {
  //     _._onPlayMovieIntroEnter();
  //   });

  //   _.resize();

  // }

  // _onPlayMovieIntroEnter(){
  //   const _ = this;
  //   console.log('playing movie!!');
  //   setTimeout(()=>{
  //     console.log('start Animation');
  //     _._startAnimation();
  //   }, ( _.movieIntroEnter.duration - 1.8)*1000)
  // }

  // _onTimeupdateMovieIntroEnter(){
  //   const _ = this;

  //   if ( _.movieIntroEnter.currentTime >  _.movieIntroEnter.duration - 2) {
  //     _.movieIntroEnter.removeEventListener('timeupdate', _._onTimeupdateMovieIntroEnter);
  //   }
  // }

  // _onEndedMovieIntroEnter(){
  //   const _ = this;

  //   _.movieIntroLoop.play();
  //   _.$movieIntroLoop.show();
  //   // _.$movieIntroEnter.hide();
  //   // _.movieIntroEnter.pause();

  //   // _.$movieIntroLoop.css({opacity:1});
  // }
}

export default Intro;
